import React, {useRef} from 'react'
import BreadCrumbsItems from "../Pages/BreadCrumbsItems/BreadCrumbsItems";
import CalendarModal from "../Calendar/CalendarModal";
import CalendarV2 from "../CalendarV2";
import Page from "../Pages/Page";
import styled from "styled-components";
import useOutsideClick from "../../hooks/useOutsideClick";
import PropTypes from "prop-types";
import {observer} from "mobx-react";

const CalendarPageTemplate2 = observer((props) => {

    return (
        <Page mobile>
            <BreadCrumbsItems style={{left: '100px'}} routes={props.breadCrumbsItems}/>
            <Styled className="calendar">
                {props.calendarModal()}
                <CalendarV2 events={props.events} onNavigate={date => props.onNavigate(date)}
                            onEventClick={props.onEventClick} onEmptyClick={props.onEmptyClick}/>
            </Styled>
        </Page>
    )
})

CalendarPageTemplate2.propTypes = {
    calendarModal: PropTypes.any,
    events: PropTypes.array,
    onEventClick: PropTypes.any,
    onEmptyClick: PropTypes.any,
}


const Styled = styled.div`

  .rbc-overlay {
    width: 400px !important;
  }

`
export default CalendarPageTemplate2